import { createI18n } from 'vue-i18n'
import messagesEn from '@/plugins/i18n/locales/en'
import messagesEs from '@/plugins/i18n/locales/es'

const language = localStorage.getItem('lang') || 'es'

export const i18n = createI18n({
  locale: language,
  fallbackLocale: language,
  availableLocales: ['en', 'es'],
  messages: {
    en: messagesEn,
    es: messagesEs
  },
  legacy: false,
  globalInjection: true
})

const loadedLanguages = [language]

export const locales = [
  {
    title: 'locales.en',
    img: '/images/flags/en.png',
    locale: 'en',
    localeISO: 'en-US'
  },
  {
    title: 'locales.es',
    img: '/images/flags/es.png',
    locale: 'es',
    localeISO: 'es-CL'
  }
]

function setI18nLanguage(lang) {
  i18n.global.locale = lang
  localStorage.setItem('lang', lang)

  return lang
}

export function getI18nLanguage() {
  return i18n.global.locale
}

export function loadLanguageAsync(lang) {
  if (i18n.global.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  loadedLanguages.push(lang)
  return setI18nLanguage(lang)
}
